<template>
  <div>
    <div class="container-fluid full-height">
      <div v-if="isWaiting" id="preloader">
        <div data-loader="circle-side"></div>
      </div>
      <!-- /Preload -->
      <div class="row row-height">
        <hello :partner="partner" show-campaign />

        <div id="start" class="col-lg-6 content-right">
          <div id="wizard_container">
            <div id="top-wizard">
              <div id="progressbar"></div>
            </div>
            <!-- /top-wizard -->
            <input id="website" name="website" type="text" value />
            <!-- Leave for security protection, read docs for details -->
            <a id="logo" href="/">
              <img
                alt
                height="30"
                src="https://s3-eu-west-1.amazonaws.com/mukellef-assets/icon.svg"
                style="display: none"
                width="30"
              />
            </a>
            <div id="middle-wizard">
              <div v-if="step !== 0 && !isWebView" class="row mb-2">
                <div class="col-5 mb-2">
                  <button
                    @click="redirectToPanel()"
                    :disabled="!dashboardUrl"
                    class="mukellef-secondary-btn panel-button"
                  >
                    {{ $t('Panele dön') }}
                  </button>
                </div>
              </div>

              <!-- // NORMAL -->
              <div class="step" v-if="$route.params.type === undefined">
                <register-step1 v-if="step === 1" ref="step1" />
                <register-step2 v-if="step === 2" :is-new-user="isNewUser" ref="step2" />
                <register-step3 v-if="step === 3" ref="step3" />
                <register-step4 v-if="step === 4" ref="step4" @total="setTotal" @set-loading="setLoading" />
              </div>

              <div v-if="step === 0" class="step">
                <div class="submit step wizard-step current">
                  <h3 v-if="!alreadyPaid" class="main_question wizard-header">
                    {{ $t('Ödemeniz başarıyla yapıldı') }}
                  </h3>
                  <h3 v-if="alreadyPaid" class="main_question wizard-header">
                    {{ $t('Başvurunuz alındı') }}
                  </h3>

                  <p>
                    {{ $t('Evrak kontrol ediliyor') }}
                  </p>

                  <div v-if="!isWebView">
                    <div class="form-group">
                      <button @click="redirectToPanel()" :disabled="!dashboardUrl" class="submit">
                        {{ $t('Panele git') }}
                      </button>
                    </div>

                    <div class="form-group">
                      <a href="#" @click="logout">{{ $t('Çıkış yap') }}</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- /middle-wizard -->
            <div v-if="step !== 0" id="bottom-wizard" class="pb-3">
              <div class="btn-toolbar row" role="toolbar" aria-label="Toolbar with button groups">
                <div
                  v-if="!checkLastStep"
                  class="btn-group col-lg-5 col-md-4 col-sm-4 col-12 first-button-group"
                  role="group"
                  aria-label="First group"
                >
                  <button
                    v-tippy="
                      this.$t('Randevu tooltip', {
                        type: this.$t('Kuruluş'),
                      })
                    "
                    class="float-left backward reservation-button w-100"
                    name="reservation"
                    type="button"
                    @click="goToReservationPage($route.params.type)"
                  >
                    {{ $t('schedule_an_appointment').toUpperCase() }}
                  </button>
                </div>
                <div class="col"></div>
                <div
                  class="btn-right-group"
                  :class="[!checkLastStep ? ['col-lg-6', 'col-md-5', 'col-sm-6', 'col-12'] : ['col-12', 'col-sm-9']]"
                  role="group"
                  aria-label="Second group"
                >
                  <button v-if="step > 1" class="backward w-100 h-100" name="backward" type="button" @click="backward">
                    {{ $t('Önceki').toUpperCase() }}
                  </button>

                  <button
                    v-if="!checkLastStep"
                    :disabled="isWaiting"
                    class="forward w-100 h-100"
                    name="forward"
                    type="button"
                    @click="forward"
                  >
                    {{ $t('Devam Et').toUpperCase() }}
                  </button>
                  <button
                    v-else
                    :disabled="isWaiting || isLoading"
                    class="process submit w-100 h-100 relative"
                    name="process"
                    type="button"
                    @click="forward"
                  >
                    <loading :active="isLoading" :is-full-page="false" background-color="#b1b3b1">
                      <div>
                        <Lottie small-size />
                      </div>
                    </loading>
                    {{ $t('Ödemeyi Tamamla').toUpperCase() }} ( {{ total }} )
                  </button>
                </div>
              </div>
              <div v-if="checkLastStep" class="float-right mt-2">
                <img
                  v-if="$route.params.type === undefined"
                  class="card-type-image"
                  src="/img/icons/kredi-kart-tipleri.png"
                />
                <img v-else class="card-type-image-global" src="/img/icons/kredi-kart-tipleri-global.png" />
              </div>
            </div>
            <!-- /bottom-wizard -->
            <!-- /row -->
          </div>
          <!-- /Wizard container -->
        </div>
        <!-- /content-right-->
      </div>
      <!-- /row-->
    </div>

    <!-- Videos -->
    <HowToChooseModal />
    <WhyAskingTCModal />
    <WhyContactInfoModal />
    <HowToPayModal />
    <CompanyAddressModal />
    <PaymentVerifyModal />
  </div>
</template>
<script>
// Videos
import HowToChooseModal from './../components/modals/videos/HowToChooseModal';
import WhyAskingTCModal from './../components/modals/videos/WhyAskingTCModal';
import HowToPayModal from './../components/modals/videos/HowToPayModal';
import WhyContactInfoModal from './../components/modals/videos/WhyContactInfoModal';
import CompanyAddressModal from './../components/modals/videos/CompanyAddressModal';
import PaymentVerifyModal from '@/components/modals/PaymentVerify';

import RegisterStep1 from '@/components/product/RegisterStep1';
import RegisterStep2 from '@/components/product/RegisterStep2';
import RegisterStep3 from '@/components/product/RegisterStep3';
import RegisterStep4 from '@/components/product/RegisterStep4';

export default {
  data() {
    return {
      isLoading: false,
      step: null,
      total: null,
      alreadyPaid: false,
      partner: null,
      dashboardUrl: null,
      lastSteppedTime: new Date(),
      isNewUser: false,
    };
  },
  created() {
    if (this.$route.query.companyId && this.$route.query.companyId === 'newuser') {
      this.isNewUser = true;
    }
    $axios.get('/tenant/companies').then((s) => {
      const companies = s.data.data;
      if (companies && companies.length > 1) {
        this.isNewUser = true;
      }
    });
    this.dashboardUrl = this.getDashboardUrl();
    this.partner = this.$route.query.partner;
    if (this.$route.query.companyId !== 'newuser') {
      this.startWaiting();
      this.$store.dispatch('getSelfWithCompanies').then(() => {
        const form = Object.assign({}, this.$store.state.selfMeData);
        this.setSelf(form);

        let queryString = '';

        for (const [k, v] of Object.entries(this.$route.query)) {
          queryString += queryString ? '&' : '?';
          if (k !== 'step') queryString += k.toString() + '=' + v.toString();
          else queryString += k.toString() + '=1';
        }

        if ((form.step === 0 && this.$route.query.companyId !== 'newuser') || this.$route.query.status === 'failure') {
          this.step = form.step;
        } else {
          this.step = 1;
        }

        this.callMukellefApp();

        this.endWaiting();
      });
    } else {
      this.step = 1;
    }
  },
  computed: {
    checkLastStep() {
      return this.step === 4;
    },
  },
  methods: {
    setLoading(data) {
      this.isLoading = data;
    },
    callMukellefApp() {
      if (this.step === 0) {
        if (window.MukellefApp) {
          const messageData = JSON.stringify({
            status: 'success',
            message: this.$route.query.message,
          });
          window.MukellefApp.postMessage(messageData);
        }
      }
    },
    redirectToPanel() {
      console.log(this.$store.state.companyData);
      window.location =
        this.dashboardUrl + '?companyId=' + (this.$store.state.companyData ? this.$store.state.companyData.id : '');
    },
    setTotal(total) {
      this.total = this.formatPrice(total.price, total.currency);
    },
    forward() {
      const func = 'sendForm';
      const step = this.step;

      if (Math.abs(new Date().getTime() - this.lastSteppedTime.getTime()) < 1000) {
        return;
      }
      this.lastSteppedTime = new Date();
      this.$refs['step' + step][func](() => {
        window.scrollTo({ top: 0 });
        this.step++;
      });
    },
    backward() {
      this.startWaiting();
      window.scrollTo({ top: 0 });
      if (this.step === 5 && this.$route.params.type === undefined && !this.$store.state.isSelectedVirtualOffice) {
        this.step--;
      }
      this.step--;
      this.toastClear();
    },
    toastClear() {
      this.$toasted.clear();
    },
  },
  components: {
    PaymentVerifyModal,
    // Videos
    HowToChooseModal,
    WhyContactInfoModal,
    HowToPayModal,
    CompanyAddressModal,
    RegisterStep1,
    RegisterStep2,
    RegisterStep3,
    RegisterStep4,
    WhyAskingTCModal,
  },
};
</script>
